module.exports = __webpack_public_path__ + "static/media/light-metamask.a8edc560.svg";